import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { ReactNode } from "react";

import APPrintablePage from "../../../../components/APPrintablePage";
import APCalculationInput from "../../../../components/calculations/APCalculationInput";
import { FinanceComparisonCalculations as FinanceComparisonCalculationsType } from "../../../../types/Calculation";
import FinanceComparisonTable from "./FinanceComparisonTable";

type DisplayedFields = {
  termMths?: boolean;
  termYrs?: boolean;

  onroadVehiclePrice?: boolean;
  residualIncGst?: boolean;
  totalRunningCosts?: boolean;

  comparison?: boolean;
};

export const FINANCE_COMPARISON_ALL_FIELDS: DisplayedFields = {
  termMths: true,
  termYrs: true,

  onroadVehiclePrice: true,
  residualIncGst: true,
  totalRunningCosts: true,

  comparison: true,
};

const FinanceComparisonCalculations = ({
  calculations,
  displayedFields,
  pageLinks,
}: {
  calculations: FinanceComparisonCalculationsType;
  displayedFields: DisplayedFields;
  pageLinks?: ReactNode;
}) => {
  const { inputs } = calculations;

  return (
    <APPrintablePage
      topContent={
        <Stack spacing={2}>
          {pageLinks}
          <Box>
            {displayedFields.termMths && (
              <APCalculationInput name="Term Months" value={inputs.termMths} />
            )}
            {displayedFields.termYrs && (
              <APCalculationInput name="Term Years" value={inputs.termYrs} />
            )}
          </Box>

          <Box>
            {displayedFields.onroadVehiclePrice && (
              <APCalculationInput
                name="Onroad Vehicle Price"
                value={inputs.onroadVehiclePrice}
                currency
              />
            )}

            {displayedFields.residualIncGst && (
              <APCalculationInput
                name="Residual Inc GST"
                value={inputs.residual.incGst}
                currency
              />
            )}

            {displayedFields.totalRunningCosts && (
              <APCalculationInput
                name="Total Running Costs"
                value={inputs.runningCosts.total}
                currency
              />
            )}
          </Box>
        </Stack>
      }
      bottomContent={
        <Stack spacing={4}>
          <Box sx={{ maxWidth: 1000 }}>
            <Typography variant="titleLarge" sx={{ mb: 1 }}>
              Comparison
            </Typography>
            <FinanceComparisonTable calculations={calculations} />
          </Box>
        </Stack>
      }
    />
  );
};

export default FinanceComparisonCalculations;
